window.app.factory("triggerDownload", [
  "toastr",
  "$q",
  function(toastr, $q) {
    function getDownloadDir() {
      if (cordova.file.documentsDirectory) {
        return $q.resolve(cordova.file.documentsDirectory);
      }
      return $q((resolve, reject) => {
        const dlDir = window.orgConfig.downloadDirName || "Download";
        window.resolveLocalFileSystemURL(
          cordova.file.externalRootDirectory,
          dirEntry => {
            dirEntry.getDirectory(
              dlDir,
              { create: true },
              dlDirEntry => {
                resolve(dlDirEntry.nativeURL);
              },
              error => {
                reject(error);
              }
            );
          },
          error => {
            reject(error);
          }
        );
      });
    }

    function downloadFile(args) {
      var fileTransfer = new window.FileTransfer();
      var uri = encodeURI(args.url);
      var okTimeout = setTimeout(() => {
        toastr.info("Downloading: " + args.filename);
      }, 500);

      return $q((resolve, reject) => {
        fileTransfer.download(
          uri,
          args.targetPath,
          function(entry) {
            console.log("download complete: " + entry.toURL());
            toastr.success("Successfully downloaded " + args.filename);
            resolve();
          },
          function(error) {
            clearTimeout(okTimeout);
            console.error("Download error", error);
            reject(error);
          },
          true,
          args.options
        );
      });
    }

    function openFile(path, mimeType) {
      const cdv = window.cordova;
      if (cdv && cdv.plugins.fileOpener2) {
        return $q((resolve, reject) => {
          cdv.plugins.fileOpener2.open(path, mimeType, {
            error: e => reject(e),
            success: () => resolve()
          });
        });
      } else {
        return $q.reject(new Error("Error: App can't open files"));
      }
    }

    return function triggerDownload(url, filename, mimeType, open) {
      filename =
        filename ||
        url
          .split("#")[0]
          .split("?")[0]
          .split("/")
          .pop();

      if (window.isMobileApp) {
        return getDownloadDir().then(downloadDir => {
          var targetPath = downloadDir + filename;
          var options = {};
          var args = { url, targetPath, options, filename };
          return downloadFile(args).then(() => {
            if (open) {
              openFile(targetPath, mimeType).catch(error => {
                console.log(error);
                toastr.error(`Could not open file "${filename}"`);
              });
            }
          });
        });
      } else {
        var link = document.createElement("a");
        link.href = url;
        if (filename) {
          link.download = filename;
        }

        link.setAttribute("type", "hidden");
        // Firefox
        document.body.appendChild(link);
        link.click();
        link.remove();

        return $q.resolve(false);
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/triggerDownload.js